import { render, staticRenderFns } from "./SignUpComponent.vue?vue&type=template&id=07e51a96&scoped=true&lang=pug&"
import script from "./SignUpComponent.vue?vue&type=script&lang=js&"
export * from "./SignUpComponent.vue?vue&type=script&lang=js&"
import style0 from "./SignUpComponent.vue?vue&type=style&index=0&id=07e51a96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e51a96",
  null
  
)

export default component.exports